// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.agent-auto-reload-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  z-index: 2100;
}

.agent-auto-reload-card {
  width: min(560px, 100%);
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  padding: 28px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  animation: agentAutoReloadIn 0.15s ease;
}

@keyframes agentAutoReloadIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.agent-auto-reload-header {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.agent-auto-reload-header h2 {
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  color: var(--color-text-primary);
}

.agent-auto-reload-header p {
  margin: 0;
  color: var(--color-text-secondary);
  font-size: 13px;
  line-height: 1.45;
}

.agent-auto-reload-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.agent-auto-reload-config {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.agent-auto-reload-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.agent-auto-reload-label {
  font-size: 13px;
  color: var(--color-text-secondary);
}

.agent-auto-reload-select {
  min-width: 120px;
  padding: 6px 10px;
  background: var(--color-bg-input);
  border: 1px solid var(--color-border-input);
  color: var(--color-text-primary);
  font-family: inherit;
  font-size: 13px;
}

.agent-auto-reload-primary,
.agent-auto-reload-secondary {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid var(--color-border-input);
  font-family: inherit;
  font-size: 14px;
  cursor: pointer;
}

.agent-auto-reload-primary {
  background: var(--color-accent-base);
  color: var(--color-text-on-accent);
  font-weight: 600;
}

.agent-auto-reload-primary:hover:not(:disabled) {
  filter: brightness(0.96);
}

.agent-auto-reload-secondary {
  background: transparent;
  color: var(--color-text-secondary);
  font-weight: 500;
}

.agent-auto-reload-secondary:hover:not(:disabled) {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

.agent-auto-reload-primary:disabled,
.agent-auto-reload-secondary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.agent-auto-reload-error {
  margin: 0;
  text-align: center;
  font-size: 13px;
  color: var(--color-danger, #e55);
}

@media (max-width: 640px) {
  .agent-auto-reload-card {
    padding: 22px 16px;
  }

  .agent-auto-reload-header h2 {
    font-size: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AgentAutoReloadModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,2CAA2C;EAC3C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uCAAuC;AACzC;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iCAAiC;EACjC,2CAA2C;EAC3C,gCAAgC;EAChC,oBAAoB;EACpB,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,2CAA2C;EAC3C,oBAAoB;EACpB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".agent-auto-reload-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  z-index: 2100;\n}\n\n.agent-auto-reload-card {\n  width: min(560px, 100%);\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  padding: 28px;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  animation: agentAutoReloadIn 0.15s ease;\n}\n\n@keyframes agentAutoReloadIn {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.agent-auto-reload-header {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.agent-auto-reload-header h2 {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n}\n\n.agent-auto-reload-header p {\n  margin: 0;\n  color: var(--color-text-secondary);\n  font-size: 13px;\n  line-height: 1.45;\n}\n\n.agent-auto-reload-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.agent-auto-reload-config {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.agent-auto-reload-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n}\n\n.agent-auto-reload-label {\n  font-size: 13px;\n  color: var(--color-text-secondary);\n}\n\n.agent-auto-reload-select {\n  min-width: 120px;\n  padding: 6px 10px;\n  background: var(--color-bg-input);\n  border: 1px solid var(--color-border-input);\n  color: var(--color-text-primary);\n  font-family: inherit;\n  font-size: 13px;\n}\n\n.agent-auto-reload-primary,\n.agent-auto-reload-secondary {\n  width: 100%;\n  padding: 10px 14px;\n  border: 1px solid var(--color-border-input);\n  font-family: inherit;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.agent-auto-reload-primary {\n  background: var(--color-accent-base);\n  color: var(--color-text-on-accent);\n  font-weight: 600;\n}\n\n.agent-auto-reload-primary:hover:not(:disabled) {\n  filter: brightness(0.96);\n}\n\n.agent-auto-reload-secondary {\n  background: transparent;\n  color: var(--color-text-secondary);\n  font-weight: 500;\n}\n\n.agent-auto-reload-secondary:hover:not(:disabled) {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n.agent-auto-reload-primary:disabled,\n.agent-auto-reload-secondary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.agent-auto-reload-error {\n  margin: 0;\n  text-align: center;\n  font-size: 13px;\n  color: var(--color-danger, #e55);\n}\n\n@media (max-width: 640px) {\n  .agent-auto-reload-card {\n    padding: 22px 16px;\n  }\n\n  .agent-auto-reload-header h2 {\n    font-size: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
